"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetChechRiconoscimentoRafforzatoAttivoDispositiva = exports.setSdkSumSubOpened = exports.resetReinforcedAuthCieSpid = exports.resetCompletamentoCampagnaRiconoscimento = exports.resetStatoCampagnaRiconoscimento = exports.getCieLink = exports.getCieButton = exports.getSpidLink = exports.getSpidButton = exports.recuperaStatoCampagnaRiconoscimento = exports.checkRiconoscimentoRafforzatoAttivoDispositiva = exports.verificaCampagnaRiconoscimentoEffettuata = exports.salvaCompletamentoCampagnaRiconoscimento = exports.resetReinforcedAuthToken = exports.getReinforcedAuthToken = void 0;
const api_rest_1 = require("@sparkasse/api-rest");
const __1 = require("..");
const general_1 = require("../general");
const general_configuration_1 = require("../general/general.configuration");
const reinforcedAuth_types_1 = require("./reinforcedAuth.types");
/* get token auth - START */
function getReinforcedAuthTokenStart() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_AUTH_TOKEN_START
    };
}
function getReinforcedAuthTokenSuccess(payload) {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_AUTH_TOKEN_SUCCESS,
        payload
    };
}
function generalError(value, showGenericModalError, sendErrorToMatomo, dispositiva, nomeEvento) {
    return async (dispatch) => {
        dispatch((0, general_1.setError)(value, showGenericModalError));
        (!!sendErrorToMatomo) && sendErrorToMatomo('REINFORCED_AUTH', `code_error REINFORCED_AUTH ${value.status} / ${value === null || value === void 0 ? void 0 : value.message} / ${value === null || value === void 0 ? void 0 : value.timestamp}`, 'REINFORCED_AUTH');
    };
}
const getReinforcedAuthToken = (externalScope) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getReinforcedAuthTokenStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/parametri_rav.json')).then(parametri => {
            dispatch(getReinforcedAuthTokenSuccess((0, api_rest_1.SumsubAccessTokenDtoFromJSON)(parametri)));
            dispatch((0, general_1.setLoader)(false));
        });
    }
    else {
        const request = {
            externalScope
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ReinforcedRecognitionControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).generateAccessToken(request).then((response) => {
                dispatch(getReinforcedAuthTokenSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getReinforcedAuthToken = getReinforcedAuthToken;
function resetReinforcedAuthToken() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_RESET_AUTH_TOKEN
    };
}
exports.resetReinforcedAuthToken = resetReinforcedAuthToken;
;
function salvaCompletamentoCampagnaRiconoscimentoStart() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_SALVA_COMPLETAMENTO_CAMPAGNA_RICONOSCIMENTO_START
    };
}
function salvaCompletamentoCampagnaRiconoscimentoSuccess(payload) {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_SALVA_COMPLETAMENTO_CAMPAGNA_RICONOSCIMENTO_SUCCESS,
        payload
    };
}
const salvaCompletamentoCampagnaRiconoscimento = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(salvaCompletamentoCampagnaRiconoscimentoStart());
    if (extraArguments.mock) {
        dispatch(salvaCompletamentoCampagnaRiconoscimentoSuccess({}));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ReinforcedRecognitionControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).campaignCompleted().then((response) => {
                dispatch(salvaCompletamentoCampagnaRiconoscimentoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.salvaCompletamentoCampagnaRiconoscimento = salvaCompletamentoCampagnaRiconoscimento;
function verificaCampagnaRiconoscimentoEffettuataStart() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_VERIFICA_CAMPAGNA_RICONOSCIMENTO_EFFETTUATA_START
    };
}
function verificaCampagnaRiconoscimentoEffettuataSuccess(payload) {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_VERIFICA_CAMPAGNA_RICONOSCIMENTO_EFFETTUATA_SUCCESS,
        payload
    };
}
const verificaCampagnaRiconoscimentoEffettuata = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(verificaCampagnaRiconoscimentoEffettuataStart());
    if (extraArguments.mock) {
        dispatch(verificaCampagnaRiconoscimentoEffettuataSuccess((0, api_rest_1.ReinforcedCampaignResponseDtoFromJSON)({})));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ReinforcedRecognitionControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).campaignExists().then((response) => {
                dispatch(verificaCampagnaRiconoscimentoEffettuataSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.verificaCampagnaRiconoscimentoEffettuata = verificaCampagnaRiconoscimentoEffettuata;
function checkRiconoscimentoRafforzatoAttivoDispositivaStart() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_CHECK_RICONOSCIMENTO_RAFFORZATO_ATTIVO_DISPOSITIVA_START
    };
}
function checkRiconoscimentoRafforzatoAttivoDispositivaSuccess(payload) {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_CHECK_RICONOSCIMENTO_RAFFORZATO_ATTIVO_DISPOSITIVA_SUCCESS,
        payload
    };
}
const checkRiconoscimentoRafforzatoAttivoDispositiva = (codFunzione) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(checkRiconoscimentoRafforzatoAttivoDispositivaStart());
    if (extraArguments.mock) {
        dispatch(checkRiconoscimentoRafforzatoAttivoDispositivaSuccess((0, api_rest_1.ReinforcedCampaignResponseDtoFromJSON)({})));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        if (!codFunzione) {
            dispatch(checkRiconoscimentoRafforzatoAttivoDispositivaSuccess({ response: false }));
            dispatch((0, general_1.setLoader)(false));
            return;
        }
        const request = {
            dispositiva: codFunzione
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ReinforcedRecognitionControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).isActiveReinforcedRecognition(request).then((response) => {
                dispatch(checkRiconoscimentoRafforzatoAttivoDispositivaSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.checkRiconoscimentoRafforzatoAttivoDispositiva = checkRiconoscimentoRafforzatoAttivoDispositiva;
function recuperaStatoCampagnaRiconoscimentoStart() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_CHECK_RECUPERA_STATO_CAMPAGNA_RICONSCIMENTO_START
    };
}
function recuperaStatoCampagnaRiconoscimentoSuccess(payload) {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_CHECK_RECUPERA_STATO_CAMPAGNA_RICONSCIMENTO_SUCCESS,
        payload
    };
}
const recuperaStatoCampagnaRiconoscimento = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(recuperaStatoCampagnaRiconoscimentoStart());
    if (extraArguments.mock) {
        dispatch(recuperaStatoCampagnaRiconoscimentoSuccess(''));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ReinforcedRecognitionControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).recoverCampaingState().then((response) => {
                dispatch(recuperaStatoCampagnaRiconoscimentoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.recuperaStatoCampagnaRiconoscimento = recuperaStatoCampagnaRiconoscimento;
function getSpidButtonStart() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_SPID_BUTTON_START
    };
}
function getSpidButtonSuccess(payload) {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_SPID_BUTTON_SUCCESS,
        payload
    };
}
const getSpidButton = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getSpidButtonStart());
    if (extraArguments.mock) {
        dispatch(getSpidButtonSuccess({}));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ReinforcedRecognitionControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).buttonSpid().then((response) => {
                dispatch(getSpidButtonSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getSpidButton = getSpidButton;
function getSpidLinkStart() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_SPID_LINK_START
    };
}
function getSpidLinkSuccess(payload) {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_SPID_LINK_SUCCESS,
        payload
    };
}
const getSpidLink = (identityProvider) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getSpidLinkStart());
    if (extraArguments.mock) {
        dispatch(getSpidLinkSuccess({}));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const request = {
            identityProvider
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ReinforcedRecognitionControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).linkSpid(request).then((response) => {
                dispatch(getSpidLinkSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getSpidLink = getSpidLink;
function getCieButtonStart() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_CIE_BUTTON_START
    };
}
function getCieButtonSuccess(payload) {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_CIE_BUTTON_SUCCESS,
        payload
    };
}
const getCieButton = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getCieButtonStart());
    if (extraArguments.mock) {
        dispatch(getCieButtonSuccess({}));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ReinforcedRecognitionControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).buttonCie().then((response) => {
                dispatch(getCieButtonSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getCieButton = getCieButton;
function getCieLinkStart() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_CIE_LINK_START
    };
}
function getCieLinkSuccess(payload) {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_GET_CIE_LINK_SUCCESS,
        payload
    };
}
const getCieLink = (identityProvider) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getCieLinkStart());
    if (extraArguments.mock) {
        dispatch(getCieLinkSuccess({}));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const request = {
            identityProvider
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ReinforcedRecognitionControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).linkCie(request).then((response) => {
                dispatch(getCieLinkSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getCieLink = getCieLink;
function resetStatoCampagnaRiconoscimento() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_RESET_STATO_CAMPAGNA_RICONOSCIMENTO
    };
}
exports.resetStatoCampagnaRiconoscimento = resetStatoCampagnaRiconoscimento;
;
function resetCompletamentoCampagnaRiconoscimento() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_RESET_COMPLETAMENTO_CAMPAGNA_RICONOSCIMENTO
    };
}
exports.resetCompletamentoCampagnaRiconoscimento = resetCompletamentoCampagnaRiconoscimento;
;
function resetReinforcedAuthCieSpid() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_RESET_CIE_SPID
    };
}
exports.resetReinforcedAuthCieSpid = resetReinforcedAuthCieSpid;
;
function setSdkSumSubOpened(payload) {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_SET_SDK_SUMSUB_OPENED,
        payload: payload
    };
}
exports.setSdkSumSubOpened = setSdkSumSubOpened;
;
function resetChechRiconoscimentoRafforzatoAttivoDispositiva() {
    return {
        type: reinforcedAuth_types_1.EReinforcedAuthActionTypes.REINFORCED_AUTH_RESET_CHECK_RICONOSCIMENTO_RAFFORZATO_ATTIVO_DISPOSITIVA
    };
}
exports.resetChechRiconoscimentoRafforzatoAttivoDispositiva = resetChechRiconoscimentoRafforzatoAttivoDispositiva;
